import { Card } from './card';
import { CardContainer } from './card-container';

export class Stock implements CardContainer {
  public revealedCards: Card[] = [];
  public cards: Card[] = [];

  constructor(value: any) {
    if (value instanceof Array) {
      this.cards = value;
    } else {
      if (value.cards.length > 0) {
        this.cards = value.cards.map((cardData: any) => new Card(cardData));
      }

      if (value.revealedCards.length > 0) {
        this.revealedCards = value.revealedCards.map((cardData: any) => new Card(cardData));
      }
    }
  }

  public simplify(): any {
    return {
      cards: this.cards.map((card: Card) => card.simplify()),
      revealedCards: this.revealedCards.map((card: Card) => card.simplify())
    };
  }

  get length(): number {
    return this.cards.length + this.revealedCards.length;
  }

  revealCards() {
    const card = this.cards.pop();
    card.hidden = false;
    this.revealedCards.push(card);
  }

  contains(card: Card): boolean {
    return this.revealedCards.indexOf(card) !== -1 || this.cards.indexOf(card) !== -1;
  }

  removeCards(cards: Card[]): void {
    this.revealedCards.splice(this.revealedCards.indexOf(cards[0]));
  }

  reset() {
    if (!this.cards.length) {
      while (this.revealedCards.length) {
        const card = this.revealedCards.pop();
        card.hidden = true;
        this.cards.push(card);
      }
    }
  }

  canAcceptCards(cards: Card[]): boolean {
    return false;
  }

  addCards(cards: Card[]): void {
    throw new Error('Method not implemented.');
  }
}
